import { useCallback } from 'react';

import { useAppSelector } from 'shared/lib/redux';

import { userEsiaIsErrorSelector, userEsiaStartStepSelector } from 'entities/user';

import {
  shouldUpdateEsiaSelector,
  showLoginByEsiaSelector,
} from 'features/AuthenticationEsia/model/AuthenticationEsia.selectors';

/**
 * Хук возвращает функцию, которая проверяет нужно ли показывать блок есиа
 * */
export const useIsShowAuthenticationEsia = () => {
  const { isEsiaAvailable } = useAppSelector(showLoginByEsiaSelector());
  const shouldUpdateSet = useAppSelector(shouldUpdateEsiaSelector);
  const isUserEsiaError = useAppSelector(userEsiaIsErrorSelector);
  const activatedStep = useAppSelector(userEsiaStartStepSelector);

  return useCallback(
    (step: string, isForceShowEsia?: boolean) => {
      return (
        (isUserEsiaError && activatedStep === step) || (isEsiaAvailable && (shouldUpdateSet[step] || isForceShowEsia))
      );
    },
    [isUserEsiaError, isEsiaAvailable, shouldUpdateSet, activatedStep],
  );
};
